__turbopack_context__.v({
  "card": "nft-assets-card-module__CDSowW__card",
  "name": "nft-assets-card-module__CDSowW__name",
  "previewImage": "nft-assets-card-module__CDSowW__previewImage",
});
